import Dao from '../api'
import { md5 } from './md5'
import { strToJson } from './lib'
import extend from 'extend2'

const DEV_ENV_TOKEN = '9a06d9063b4610865ac3a508ca1dc700'

const getLocalConfig = () => {
  let runTimeConfig = {}
  try {
    // eslint-disable-next-line
    runTimeConfig = require(`../env.${process.env.NODE_ENV}.json`);
  } catch (error) {}
  /*eslint-disable*/
  const defaultConfig = require(`../config/config.default.js`).default;
  return {
    runTimeConfig,
    defaultConfig,
  }
}

const verifySign = (sign, remoteHostname) => {
  return sign === md5(remoteHostname)
}

const getSign = (env) => {
  return env === 'development'
    ? DEV_ENV_TOKEN
    : md5(location.hostname)
}

export const getRemoteAppConfig = async (env) => {
  const sign = getSign(env)
  const response = await Dao.get(`/api/app-config/${sign}`)
  const appConfig = response.data.data
  if (!appConfig) {
    return null
  }
  if (!verifySign(sign, appConfig.Domain)) {
    return null
  }

  const remoteConfig = strToJson(appConfig.JsonConfig);
  const local = getLocalConfig();
  const config = extend(
    true,
    {},
    local.defaultConfig,
    local.runTimeConfig,
    remoteConfig
  );

  if (!config.consoleURL || !config.userURL) {
    return null;
  }
  return config;
}


export const getDomain = () => {
  const hostname = location.hostname
  // IP 直接返回hostname
  if (/((25[0-5]|2[0-4]\d|((1\d{2})|([1-9]?\d)))\.){3}(25[0-5]|2[0-4]\d|((1\d{2})|([1-9]?\d)))/.test(hostname)) {
    return hostname
  }
  let hostArr = hostname.split('.')
  return '.' + hostArr.slice(-2).join('.')
}



// WEBPACK FOOTER //
// ./src/utils/app.js